import { render, staticRenderFns } from "./BatchPromotionRecord.vue?vue&type=template&id=008a23ac"
import script from "./BatchPromotionRecord.vue?vue&type=script&lang=js"
export * from "./BatchPromotionRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports